import React, { FC } from "react"
import { reportErrorMessage } from "../../utils/ErrorReporting"
import { useContentfulConditions } from "./hooks/useContentfulConditions"

export type Condition = {
  conditionType: ConditionType
  attributes: Array<string>
}

export type ConditionalGatePropsTest = {
  conditions: Array<Condition>
}

enum ConditionType {
  CANT_HAVE = "cantHave",
  MUST_HAVE = "mustHave",
  HAS_ANY = "hasAny"
}

export const ConditionalGate: FC<ConditionalGatePropsTest> = ({ children, conditions }) => {
  const conditionsMap = useContentfulConditions()
  const GetUserStateValues = (attributeKeys: Array<string>): Array<boolean> => {
    return attributeKeys.map((key) => {
      if (typeof conditionsMap[key] === "undefined") {
        reportErrorMessage(`No mapping for Contentful attribute with key: ${key}`)
        return false
      } else {
        return conditionsMap[key].value
      }
    })
  }

  const DoesUserSatisfyConditions = (conditions: Array<Condition>): boolean => {
    if (!conditions) return true

    for (const { attributes, conditionType } of conditions) {
      const userStateValues = GetUserStateValues(attributes)

      switch (conditionType) {
        case ConditionType.CANT_HAVE:
          if (userStateValues.some(Boolean)) return false
          break
        case ConditionType.MUST_HAVE:
          if (!userStateValues.every(Boolean)) return false
          break
        case ConditionType.HAS_ANY:
          if (!userStateValues.some(Boolean)) return false
          break
      }
    }

    return true
  }

  return DoesUserSatisfyConditions(conditions) ? <>{children}</> : null
}
